import React from 'react';
import { CSVUtility } from './pages/CSVUtility';
export function App() {
  return <CSVUtility data-id="element-0" />;
}